import { browser } from './xesFunction'

export const isApp = browser.isApp // 是否是原生app
export const isWeixin = browser.weixin
export const isIOS = browser.ios
export const isAndroid = browser.android
export const isYach = browser.yach
